"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Color: () => Color
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_materialColor = require("./materialColor");
__reExport(index_native_exports, require("./android.dynamic.types"), module.exports);
__reExport(index_native_exports, require("./android.material.types"), module.exports);
__reExport(index_native_exports, require("./ios.types"), module.exports);
var iosColor = new Proxy({}, {
  get(_, prop) {
    if (import_react_native.Platform.OS === "ios") return (0, import_react_native.PlatformColor)(prop);
    return null;
  }
});
var androidMaterialColor = new Proxy({}, {
  get(_, prop) {
    if (import_react_native.Platform.OS === "android") return (0, import_materialColor.Material3Color)(prop);
    return null;
  }
});
var androidDynamicColor = new Proxy({}, {
  get(_, prop) {
    if (import_react_native.Platform.OS === "android") return (0, import_materialColor.Material3DynamicColor)(prop);
    return null;
  }
});
var androidColor = new Proxy({
  get material() {
    return androidMaterialColor;
  },
  get dynamic() {
    return androidDynamicColor;
  }
}, {
  get(target, prop) {
    if (prop in target) return target[prop];
    if (import_react_native.Platform.OS === "android") return (0, import_react_native.PlatformColor)("@android:color/" + prop);
    return null;
  }
});
var Color = {
  get ios() {
    return iosColor;
  },
  get android() {
    return androidColor;
  }
};
//# sourceMappingURL=index.native.js.map
